import { Component, input, model, ViewChild } from '@angular/core';
import { SynergyFormsModule, SynInputComponent } from '@synergy-design-system/angular';
import { PasswordRequirementsComponent } from './password-requirements.component';
import { HelpTextComponent } from './help-text.component';

@Component({
  selector: 'app-password-input',
  template: `
    <app-help-text [enabled]="helpText().length > 0">
      <div class="flex-col">
        <syn-input
          [label]="label()"
          [(value)]="password"
          [disabled]="disabled()"
          [passwordToggle]="true"
          type="password"
        />
        <app-theme-password-requirements
          [password]="password()"
          [alwaysShowRequirements]="alwaysShowRequirements()"
        />
      </div>
      @if (helpText().length > 0) {
        <span helpText>
          {{ helpText() }}
        </span>
      }
    </app-help-text>
  `,
  styles: [
    `
      syn-input {
        width: 100%;
      }
    `,
  ],
  imports: [SynInputComponent, PasswordRequirementsComponent, SynergyFormsModule, HelpTextComponent],
})
export class PasswordInputComponent {
  password = model('');
  alwaysShowRequirements = input(false);

  placeholder = input('');
  label = input('');
  helpText = input('');
  disabled = input(false);
  required = input(false);

  @ViewChild(PasswordRequirementsComponent) requirements?: PasswordRequirementsComponent;

  public isValid() {
    return this.requirements?.isValid() ?? false;
  }
}
